import zxcvbn from 'zxcvbn';

function PasswordStrengthInit() {
    // run after everything is in-place
    $(window).resize(function () {
      var e = window.innerHeight;
    }), $(document).ready(function () {
      function e() {
        r.get(0).width = u.width(), r.get(0).height = u.height()
      }

      function a() {
        var e = u.width(), a = u.height();
        s = u.width() / u.height(), o = e, l = a, c = 0, d = 0, s > t ? (l = Math.round(e / t), d = (a - l) / 2) : (o = Math.round(a * t), c = (e - o) / 2);
        var i = .01 * g;
        m.mozImageSmoothingEnabled = 1 === i, m.webkitImageSmoothingEnabled = 1 === i, m.imageSmoothingEnabled = 1 === i, m.clearRect(0, 0, r.width(), r.height()), m.drawImage(h, 0, 0, e * i, a * i), m.drawImage(r.get(0), 0, 0, e * i, a * i, c, d, o + .05 * e, l + .05 * a)
      }

      setTimeout(function () {
        var e = $(window).innerHeight;
      }, 100);


      var r = $(".strength-indicator");
      if (r.length) {
        var t, s, o, l, c, d, u = r.parent(), m = r.get(0).getContext("2d"), h = new Image, g = 1;
        h.src = "/img/under-square-pattern.jpg", h.onload = function () {
          t = h.width / h.height, e(), a()
        }, $(window).resize(function () {
          e(), a()
        })

        $('input[name="password"]').on("input", function () {
          var e = this.value, i = zxcvbn(e);
          g = 9 * Math.min(11, Math.round(i.guesses_log10)) + 1, 1 != g && 100 != g && (g -= g / 100 * 50), a()
        })
      }
    });
}

export {PasswordStrengthInit};